var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.769C10.3137 12.769 13 10.0828 13 6.76904C13 3.45533 10.3137 0.769043 7 0.769043C3.68629 0.769043 1 3.45533 1 6.76904C1 10.0828 3.68629 12.769 7 12.769Z",
    stroke: "#6301CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85142 11.8543L2.84619 19.2308L7.00004 16.8017L11.1539 19.2308L10.1487 11.8462",
    stroke: "#6301CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderMedal);
export default __webpack_public_path__ + "static/media/leaderMedal.6be70497ffb885ee022da0571f667c95.svg";
export { ForwardRef as ReactComponent };